var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "doc-file",
    clipPath: "url(#clip0_1050_30614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7031 0.000244141H6.06368C4.65541 0.000244141 3.50927 1.14718 3.50927 2.55461V12.0002H3.25973C2.69136 12.0002 2.23047 12.4607 2.23047 13.0296V19.2719C2.23047 19.8407 2.69136 20.3012 3.25973 20.3012H3.50927V21.4458C3.50927 22.8548 4.65541 24.0002 6.06363 24.0002H19.216C20.6235 24.0002 21.7696 22.8548 21.7696 21.4458V6.04574L15.7031 0.000244141ZM3.93328 13.887C4.29302 13.8297 4.76168 13.7975 5.25643 13.7975C6.07856 13.7975 6.61169 13.9451 7.02942 14.2596C7.47897 14.5938 7.76136 15.1274 7.76136 15.8915C7.76136 16.7199 7.4597 17.2918 7.04197 17.6449C6.58615 18.0237 5.89229 18.2034 5.04462 18.2034C4.53708 18.2034 4.17734 18.1713 3.93333 18.1391L3.93328 13.887ZM19.2161 22.4359H6.06368C5.51836 22.4359 5.07434 21.9918 5.07434 21.4458V20.3012H17.3352C17.9035 20.3012 18.3645 19.8407 18.3645 19.2719V13.0296C18.3645 12.4607 17.9036 12.0002 17.3352 12.0002H5.07434V2.55461C5.07434 2.01013 5.51836 1.56611 6.06368 1.56611L15.1178 1.55666V4.90338C15.1178 5.88093 15.911 6.67484 16.8892 6.67484L20.1677 6.66543L20.2046 21.4458C20.2046 21.9918 19.7613 22.4359 19.2161 22.4359ZM8.20692 16.0263C8.20692 14.7288 9.03543 13.7591 10.3138 13.7591C11.6436 13.7591 12.3692 14.7547 12.3692 15.9494C12.3692 17.3687 11.5086 18.2293 10.2431 18.2293C8.95857 18.2293 8.20692 17.2597 8.20692 16.0263ZM15.23 17.4134C15.5253 17.4134 15.8528 17.349 16.0458 17.2721L16.1933 18.0363C16.0137 18.1266 15.6089 18.2231 15.0825 18.2231C13.5856 18.2231 12.8148 17.2918 12.8148 16.0586C12.8148 14.5813 13.8684 13.7592 15.1785 13.7592C15.6861 13.7592 16.0713 13.8619 16.2447 13.9513L16.0458 14.7288C15.8465 14.6448 15.5703 14.568 15.2236 14.568C14.4462 14.568 13.8425 15.0372 13.8425 16.0005C13.8426 16.8674 14.3564 17.4134 15.23 17.4134Z",
    fill: "#096DD9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.72122 15.9236C6.72749 15.0238 6.20074 14.5492 5.35929 14.5492C5.14076 14.5492 4.99954 14.568 4.91602 14.5876V17.4197C4.99954 17.4394 5.13454 17.4394 5.25655 17.4394C6.14305 17.4456 6.72122 16.9576 6.72122 15.9236Z",
    fill: "#096DD9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.335 15.9809C11.335 15.2042 10.9624 14.5358 10.2881 14.5358C9.62635 14.5358 9.24072 15.1657 9.24072 16.0068C9.24072 16.8548 9.63925 17.4518 10.2944 17.4518C10.9561 17.4518 11.335 16.8226 11.335 15.9809Z",
    fill: "#096DD9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1050_30614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileDoc);
export default __webpack_public_path__ + "static/media/icon-file-doc.8599a55c48c822024c413c3b0b143118.svg";
export { ForwardRef as ReactComponent };